<script setup>
import { computed } from 'vue'

const props = defineProps({
    name: {
        type: String,
        default: 'U', // Unassigned
        required: true
    },
    bgColor: {
        type: String,
        default: '#875BF7'
    },
    img: {
        type: String,
        required: true
    },
    textClass: {
        type: String,
        default: ''
    },
    imgClass: {
        type: String,
        default: ''
    },
    secondary: {
        type: Boolean,
        default: false
    },
    secondaryName: {
        type: String,
        default: 'U', // Unassigned
    },
    secondaryBgColor: {
        type: String,
        default: '#875BF7'
    },
    secondaryImg: {
        type: String,
    },
    secondaryTextClass: {
        type: String,
        default: ''
    },
    secondaryImgContainer: {
        type: String,
    },
    secondaryImgClass: {
        type: String,
        default: ''
    }
})

const bg = computed(() => {
    if (!props.bgColor) return '#875BF7'

    return props.bgColor
})

const secondaryBg = computed(() => {
    if (!props.bgColor) return '#875BF7'

    return props.secondaryBgColor
})

const colors = computed(() => {
    if (typeof prebook_admin !== 'undefined' && prebook_admin) {
        return prebook_admin.options.color_sets
    } else {
        return prebook.options.color_sets
    }
})

const textColor = computed(() => {
    return colors.value[bg.value]
})

const secondaryTextColor = computed(() => {
    return colors.value[secondaryBg.value]
})

</script>

<template>
    <div v-bind="$attrs" class="relative">
        <div v-if="props.img" :class="`prebook-profile-picture ${props.imgClass}`" :style="`background-image: url(${props.img});`"></div>
        <div v-else :class="`prebook-profile-picture-fallback ${props.textClass}`" :style="`background-color: ${bg}; color: ${textColor};`">{{ props.name[0] }}</div>
        <div v-if="props.secondary" :class="`absolute -bottom-[6px] -right-[6px] w-7 h-7 ${props.secondaryImgContainer}`">
            <div v-if="props.secondaryImg" :class="`prebook-profile-picture ${props.secondaryImgClass}`" :style="`background-image: url(${props.secondaryImg});`"></div>
            <div v-else :class="`prebook-profile-picture-secondary-fallback ${props.secondaryTextClass}`" :style="`background-color: ${secondaryBg}; color: ${secondaryTextColor};`">{{ props.secondaryName[0] }}</div>
        </div>
    </div>
</template>

<style lang="scss">
.prebook-profile-picture {
    border-radius: 9999px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.prebook-profile-picture-fallback {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 9999px;
    width: 100%;
    height: 100%;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 24px;
}

.prebook-profile-picture-secondary-fallback {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 9999px;
    width: 100%;
    height: 100%;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 18px;
}
</style>